import Breadcrumb from '../components/Breadcrumb'
import AOS from "aos";
import "aos/dist/aos.css"; // AOS style
import { useEffect } from 'react';
import { seminarlar } from '../utils/Data';
import { Link } from 'react-router-dom';

function Seminar() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
        });
    }, []);
    return (
        <>
            <Breadcrumb text='Seminarlar' />

            <section className="my-120 @">
                <div className="container-xl">
                    <div className="section-title center">
                        <div className="section-title-inner center w-v4">
                            <h4 className="sub-title" data-aos="fade-down" data-aos-duration="1000">Seminar</h4>
                            <h2 className="big-title s-color-black" data-aos="fade-up" data-aos-duration="1000">
                                Barcha seminar mashg'ulotlar
                            </h2>
                        </div>
                    </div>
                    <div className="row">
                        {
                            seminarlar.map(seminar => {
                                return <div
                                    key={seminar.id}
                                    className="col-xl-4 col-lg-4 col-md-6 col-sm-6"
                                    data-aos="fade-up"
                                    data-aos-duration="800"
                                    data-aos-delay="100"
                                >
                                    <div className="news-card">
                                        <div className="news-card-img">
                                            <Link to={`/seminar/${seminar.id}`}>
                                                <img src={seminar.image} alt={seminar.title} />
                                            </Link>
                                        </div>
                                        <div className="news-card-content">
                                            <div className="content-top">
                                                <div className="date"><div className="content-icon"><i className="fas fa-bookmark"></i></div>Seminar</div>
                                            </div>
                                            <h4 className="title">
                                                <Link to={`/seminar/${seminar.id}`}>{seminar.title}</Link>
                                            </h4>
                                            <p className="para">
                                                {seminar.description.length > 110 ? seminar.description.slice(0, 110) + '...' : seminar.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </div>
            </section>
        </>
    )
}

export default Seminar